import React from "react"
import NumberFormat from "components/TouchDesign/Components/PriceInput"
import { TextField } from "./TextField"
import { EuroAdornment } from "../../lib"

/**
 * @param {import("@mui/material").TextFieldProps & import("formik").FieldProps & {euro?: boolean; decimalScale?: number;}} props
 */
export const PriceInput = ({ InputProps, euro, decimalScale = 2, ...rest }) => {
  const euroProps = {
    endAdornment: EuroAdornment
  }

  return (
    <TextField
      {...rest}
      InputProps={{
        ...InputProps,
        ...(euro ? euroProps : {}),
        inputComponent: NumberFormat,
        inputProps: {
          decimalScale,
          allowEmptyFormatting: false,
          suffix: "",
          ...(InputProps?.inputProps || {})
        }
      }}
    />
  )
}
